import { useEffect, useMemo, useState } from "react";

export function useTypingAnimation(texts: string[]) {
  const [index, setIndex] = useState(0);
  const textHash = texts.toString();

  const animation = useMemo(() => {
    const animationArray: { text: string; delay: number }[] = [];
    const paddedTexts = texts.map(t => " " + t);

    const animation = async () => {
      const stepUp = 100;
      const stepDown = 75;
      const blinkOn = 600;
      const blinkOff = 400;
      const regularBlinks = 2;
      const mainBlinks = 4;

      const animateString = (text: string, blinks: number) => {
        for (let i = 0; i < text.length + 1; i++) {
          animationArray.push({ text: text.slice(0, i) + "_", delay: stepUp });
        }

        animationArray[animationArray.length - 1].delay += blinkOn;

        for (let i = 0; i < blinks; i++) {
          animationArray.push({
            text: animationArray[animationArray.length - 1].text.slice(0, -1),
            delay: blinkOff,
          });

          animationArray.push({
            text: animationArray[animationArray.length - 1].text + "_",
            delay: blinkOn,
          });
        }

        for (let i = text.length + 1; i >= 0; i--) {
          animationArray.push({
            text: text.slice(0, i) + "_",
            delay: stepDown,
          });
        }
      };

      for (let s of paddedTexts.slice(1)) {
        animateString(s, regularBlinks);
      }

      animateString(paddedTexts[0], mainBlinks);
    };

    animation();

    return animationArray;
  }, [textHash]);

  useEffect(() => {
    const timeout = setTimeout(
      () => setIndex(index => index + 1),
      animation[index % animation.length].delay,
    );

    return () => clearTimeout(timeout);
  }, [index, animation]);

  return animation[index % animation.length].text;
}
